import { Link } from "gatsby"
import React, { useState } from "react"

export default function Nav() {
  const [isExpanded, toggleExpansion] = useState(false)

  return (
    /*--Nav-- */
    <nav
      id="header"
      className="absolute w-full z-30 top-0 text-white bg-transparent"
    >
      <div class="w-full mx-auto flex flex-wrap items-center justify-between mt-0 py-2">
        <div class="pl-4 flex items-center">
          <a
            class="toggleColour text-white no-underline hover:no-underline font-bold text-xl lg:text-4xl"
            href="#"
          >
            {/*--Icon from: http://www.potlabicons.com/ --*/}
            <svg
              class="h-12 fill-current inline"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <rect fill="white" />
              <path d="M0 316c0 15 6 29 16 40l12 11c10 11 24 16 39 16s29-5 40-16l115-115a128 128 0 0 0 161-124c0-18-3-35-10-51l-1-1v-1l-1-2-1-1-1-1-2-1-1-1-1-1-1-1h-3l-2-1h-3l-2 1h-1l-2 1h-1l-1 1-2 1-1 1-68 68-33-34 67-68 1-1 1-1 1-2 1-1v-2l1-1v-1-2-1-2l-1-2v-1l-1-1v-2l-1-1-1-1-1-1-2-1-1-1-1-1h-1a128 128 0 0 0-175 150L16 276a56 56 0 0 0-16 40zM255 32l16 1-49 49a32 32 0 0 0 0 46l34 34a32 32 0 0 0 45 0l49-49 1 15a96 96 0 0 1-128 90 96 96 0 0 1 32-186zM39 299l106-106 1 2 6 8 3 4c6 8 13 15 21 22l4 2 9 6 1 1L84 344c-9 9-25 10-34 0l-11-11a24 24 0 0 1 0-34zm0 0" />
            </svg>{" "}
            Code With Me !
          </a>
        </div>
        {/*768px以下なら隠す　それ以上ならブロック表示*/}
        <button
          className="items-center block px-3 py-2 text-white border border-white rounded md:hidden mr-5"
          onClick={() => toggleExpansion(!isExpanded)}
        >
          <svg
            className="w-3 h-3 fill-current"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <title>Menu</title>
            <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
          </svg>
        </button>
        <nav
          className={`${
            isExpanded ? `block gradient md:hidden` : `hidden`
          } md:mr-10 md:block md:items-center w-full md:w-auto`}
        >
          {[
            {
              route: `#about`,
              title: `講師紹介`,
            },
            {
              route: `#works`,
              title: `作るもの一覧`,
            },
            {
              route: `#recuriting`,
              title: `募集案内`,
            },
            {
              route: `#contact`,
              title: `お問い合わせ`,
            },
          ].map(link => (
            <Link
              className={`${
                isExpanded ? `my-10 font-bold text-center` : ``
              } block no-underline md:inline-block md:mt-0 md:ml-6 text-white`}
              key={link.title}
              to={link.route}
            >
              {link.title}
            </Link>
          ))}
        </nav>
      </div>

      <hr class="border-b border-gray-100 opacity-25 my-0 py-0" />
    </nav>
  )
}
